import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { Paper, SelectField, MenuItem} from "material-ui"
import WorkforceOptimization from "./workforce-optimization/WorkforceOptimization"
import CostSavingsWave from "./cost-savings-wave/CostSavingsWave"

declare global {
    interface Window {
        Intercom: any
    }
}

interface IProps {
}

interface IState {
    loading: boolean
    activeDashboard: string
}
export default class WorkforceAssessment extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            activeDashboard: "wfo"
        }
        autobind(this)
    }

    componentDidMount() {
        document.title = `${strings.Dashboard} | Workforce Assessment`
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <Paper style={{padding:20}}>
                <div style={{ fontSize: 25, textAlign: "left", marginTop: 20, marginBottom: 20}}>
                    <SelectField
                            floatingLabelText={strings.Dashboard}
                            value={this.state.activeDashboard}
                            onChange={(event, key, value) => {
                                this.setState({ activeDashboard: value})
                            }}
                            style={{ width: 250 }}
                        >
                        <MenuItem value={"wfo"} primaryText={strings.Workforce_Optimization} />
                        <MenuItem value={"wave"} primaryText={strings.Cost_Savings} />
                    </SelectField>                
                </div>
                {this.state.activeDashboard == "wfo" && 
                    <WorkforceOptimization />
                }
                {this.state.activeDashboard == "wave" && 
                    <CostSavingsWave />
                }                
            </Paper >
        )
    }
}